import { FC, ReactElement } from 'react';
import { Navigate } from 'react-router-dom';

import { useGuard } from '../Hooks/useGuard';

interface ProtectedRouteProps {
   element: ReactElement;
   requiredPermission?: string;
   requiredRole?: string;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
   element,
   requiredPermission,
   requiredRole,
}) => {
   const { hasPermission, hasRole } = useGuard();

   if (requiredPermission && !hasPermission(requiredPermission)) {
      return (
         <Navigate
            to={`${process.env.PUBLIC_URL}/error/unauthorized`}
            replace
         />
      );
   }

   if (requiredRole && !hasRole(requiredRole)) {
      return (
         <Navigate
            to={`${process.env.PUBLIC_URL}/error/unauthorized`}
            replace
         />
      );
   }

   return element;
};
